export default __webpack_public_path__ + "static/media/triangle.3ae6a659.svg";